/**
 * スペーシングとブレークポイント
 * レイアウトの間隔とレスポンシブデザインのブレークポイント定義
 *
 * このファイルには以下のカテゴリが含まれます：
 * - スペーシング: マージンやパディングに使用する間隔
 * - ブレークポイント: レスポンシブデザイン用の画面サイズ境界値
 */

/**
 * スペーシング
 * アプリケーション全体で使用する統一的な間隔の定義
 */
export const SPACING = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px',
} as const;

/**
 * ブレークポイント - より細かいレスポンシブ設計
 * 様々なデバイスサイズに対応するための画面幅の境界値
 */
export const BREAKPOINTS = {
  // 従来との互換性
  mobile: '320px',
  tablet: '768px',
  desktop: '1024px',
  wide: '1440px',

  // より詳細なブレークポイント
  xs: '320px', // 小型スマートフォン
  sm: '576px', // 大型スマートフォン
  md: '1500px', // タブレット - 1360px以下でタブレットレイアウト表示
  lg: '2000px', // 小型デスクトップ
  xl: '3000px', // デスクトップ
  '2xl': '4000px', // 大型デスクトップ

  // 特定デバイス向け
  phone: '480px',
  tabletPortrait: '768px',
  tabletLandscape: '1024px',
  laptopSmall: '1366px',
  laptop: '1440px',
  desktop4K: '1920px',
} as const;

/**
 * ボーダーラジウス - 現代的な角の丸み
 * UIコンポーネントの角の丸みを統一的に管理
 */
export const BORDER_RADIUS = {
  none: '0',
  xs: '2px',
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '16px',
  '2xl': '20px',
  '3xl': '24px',
  full: '9999px',
} as const;
